(function ($) {
  $(() => {
    const $bookmarkStatusButtons = $('.c-bookmark-status');
    
    console.log($bookmarkStatusButtons.attr('data-loggedin') == false);
    if ($bookmarkStatusButtons.attr('data-loggedin') == false) {
      // Not logged in: bind toggle to existing twig-rendered panel
      if ($bookmarkStatusButtons.length > 0) {
        $bookmarkStatusButtons.attr('type', 'button');

        function closeAllPanels() {
          $('.js-bookmark-panel').attr('aria-hidden', 'true').removeClass('is-open');
          $('.c-bookmark-status').attr('aria-expanded', 'false');
        }

        // Global outside/escape handlers (once)
        $(document).off('click.bookmarkPanel').on('click.bookmarkPanel', (e) => {
          if (!$(e.target).closest('.js-bookmark-panel, .c-bookmark-status').length) {
            closeAllPanels();
          }
        });
        $(document).off('keydown.bookmarkPanel').on('keydown.bookmarkPanel', (e) => {
          if (e.key === 'Escape') {
            closeAllPanels();
          }
        });

        $bookmarkStatusButtons.each(function () {
          const $btn = $(this);
          const $panel = $btn.next('.js-bookmark-panel');

          $btn.on('click', (e) => {
            e.preventDefault();
            if ($panel.hasClass('is-open')) {
              $panel.attr('aria-hidden', 'true').removeClass('is-open');
              $btn.attr('aria-expanded', 'false');
            } else {
              closeAllPanels();
              $panel.attr('aria-hidden', 'false').addClass('is-open');
              $btn.attr('aria-expanded', 'true');
            }
          });
        });
      }
      return;
    }

    if ($bookmarkStatusButtons.length > 0) {
      $bookmarkStatusButtons.each(function () {
        // eslint-disable-next-line no-undef
        const bookmarkComponent = new BookmarkComponent(
          $(this),
          // eslint-disable-next-line no-undef
          ajax_url,
          'wpfe_post_bookmark_status',
          'wpfe_add_bookmark',
          'wpfe_delete_bookmark',
        );
        bookmarkComponent.init();
      });
    }
  }); // End of DOM Ready
}(jQuery));


(function ($) {
    'use strict';

    $(function () {
        bookmarkListeners();
    });

  function bookmarkListeners() {
        $('.wpfe-bookmark-list').on('click', '.js-wpfe-delete-bookmark', deleteWpfeBookmark);
    }

  function deleteWpfeBookmark() {
        if (typeof wpfe_bookmark_delete_url === 'undefined') {
            return;
        }

        let bookmarkId = $(this).parents('.wpfe-bookmark-item').data('bookmark-id');
        if (typeof bookmarkId === 'undefined') {
          return;
        }
    
        let postId = $(this).parents('.wpfe-bookmark-item').data('post-id');
        if (typeof postId === 'undefined') {
          return;
        }
    
        $.post(wpfe_bookmark_delete_url, { 'bookmarkId': bookmarkId, 'postId': postId, 'withFlash': true }, function (result) {
        }).always(function () {
            location.reload();
        });
    }

})(jQuery);

